import React, {useContext, useEffect, useRef, useState} from "react"
import Row from "@amzn/meridian/row"
import Column from "@amzn/meridian/column"
import Select, {SelectOption} from "@amzn/meridian/select"
import RefreshTimer from "../../util/RefreshTimer";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import {FormattedMessage, injectIntl} from "react-intl";
import {AdtaDeviceOverviewContext} from "./context/AdtaDeviceOverviewContext";
import {getRefreshInterval} from "../../util/Util";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import AddAdtaSorterConfigurationModal from "./modal/AddAdtaSorterConfigurationModal";
import Alert from "@amzn/meridian/alert";
import Loader from "../../loader/Loader";
import chevronDownLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-down-large"
import Tooltip from "@amzn/meridian/tooltip";
import DeleteAdtaSorterConfigurationModal from "./modal/DeleteAdtaSorterConfigurationModal";
import AddEditViaJsonModal from "../../commonui/AddEditViaJsonModal";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import plusCircleTokens from "@amzn/meridian-tokens/base/icon/plus-circle";
import AddAdtaSorterTestPackageModal from "./modal/AddAdtaSorterTestPackageModal";
import DeleteAdtaSorterTestPackageModal from "./modal/DeleteAdtaSorterTestPackageModal";

const AdtaDeviceConfiguration = ({intl}) => {

    const {viewModel, dispatch} = useContext(AdtaDeviceOverviewContext);
    const [openAddModal, setOpenAddModal] = useState(false)
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [valueConfiguration, setValueConfiguration] = useState()
    const [selectedMac, setSelectedMac] = useState("")
    const tableEndRef = useRef(null)

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, []);

    const sortedDeviceList = Object.values(viewModel.adtaDeviceInformation);
    sortedDeviceList && sortedDeviceList.sort((a, b) => {
        if (a.name < b.name) {
            return -1
        } else if (b.name > a.name) {
            return 1
        }
        return 0
    })

    const getData = () => {
        setOpenAddModal(false)
        setOpenDeleteModal(false)
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});
    }
    const scrollToBottom = () => {
        tableEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    function onClickAddSingle() {
        setOpenAddModal(true)
    }

    function onClickDeleteConfiguration() {
        setOpenDeleteModal(true)
    }

    if (viewModel.loadingOverview) {
        return (<Loader/>)
    } else {
        return (
            <Column>
                <Box type="fill" spacingInset="medium">
                    <Row width="100%" widths={["100", "fill", "100", "fill"]}>
                        <Row>
                            <Text>
                                <FormattedMessage id="configtype.title" defaultMessage="Select Config Type"/>
                            </Text>
                            <Select
                                value={valueConfiguration}
                                onChange={(value) => {
                                    setValueConfiguration(value);
                                    setSelectedMac("");
                                }}
                                placeholder="Select Config Type"
                                width={300}>
                                <SelectOption key="Sorter Destination" value="Sorter Destination"
                                              label="Sorter Destination"/>
                                <SelectOption key="Sorter Test Package" value="Sorter Test Package"
                                              label="Sorter Test Package"/>
                            </Select>
                        </Row>
                        <Box></Box>
                        {(valueConfiguration === "Sorter Destination" || valueConfiguration === "Sorter Test Package") &&
                            <Row>
                                <Text>
                                    <FormattedMessage id="devicename.title" defaultMessage="Select Device"/>
                                </Text>
                                <Select
                                    value={selectedMac}
                                    onChange={setSelectedMac}
                                    placeholder="Select Device"
                                    width={300}>
                                    {sortedDeviceList.map((device) => (
                                        <SelectOption key={device.mac} value={device.mac}
                                                      label={device.name + " (" + device.mac + ")"}/>
                                    ))}
                                    {!sortedDeviceList.length ? (
                                        <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                            <Text alignment="center"> No devices available </Text>
                                        </Column>) : null}
                                </Select>
                            </Row>}
                        <Box></Box>
                    </Row>
                </Box>
                {valueConfiguration === "Sorter Destination" && selectedMac && <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel]}/>
                        <Box></Box>
                        <Tooltip position="top" title={intl.formatMessage({
                            id: 'tooltip.scrolltobottom',
                            defaultMessage: 'Scroll to bottom!'
                        })}>
                            <Button onClick={scrollToBottom}
                                    type="secondary"
                                    size="small">
                                <Icon tokens={chevronDownLargeTokens}/>
                            </Button>
                        </Tooltip>
                    </Row>
                    {(viewModel.sorterConfig[selectedMac]).length === 0 ?
                        <Alert type="informational" size="small">
                            <FormattedMessage id="alert.config"
                                              defaultMessage=" No Configurations present for this MAC Address."/>
                        </Alert> :
                        <Table
                            headerRows={1}
                            spacing="small"
                            showDividers={true}
                            showStripes={true}>
                            <TableRow highlightOnHover={false}>
                                <TableCell>
                                    <FormattedMessage id="bay.index" defaultMessage="Index"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="bay.id" defaultMessage="Bay ID"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="bay.installationtype" defaultMessage="Installation Type"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="bay.location" defaultMessage="Locations"/>
                                </TableCell>
                            </TableRow>
                            {Object.values(viewModel.sorterConfig[selectedMac].map((device, index) => (
                                <TableRow highlightOnHover={true}>
                                    <TableCell>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell>
                                        {device.bayId}
                                    </TableCell>
                                    <TableCell>
                                        {device.type}
                                    </TableCell>
                                    <TableCell>
                                        {Array.isArray(device.locations) ? device.locations.join(' ') : device.locations}
                                    </TableCell>
                                </TableRow>
                            )))}
                        </Table>}
                    <Row width="100%" widths={["100", "100", "fill", "100"]}>
                        <Button onClick={onClickAddSingle}
                                type="primary"
                                size="small">
                            <Icon tokens={plusCircleTokens}/>
                            <FormattedMessage id="config.addupdate"
                                              defaultMessage="Add/Update Sorter Destination Configuration"/>
                        </Button>
                        <AddEditViaJsonModal/>
                        <Box></Box>
                        <Button onClick={onClickDeleteConfiguration} size="small" type="tertiary">
                            <Icon tokens={trashTokens}/>
                            <FormattedMessage id="config.delete" defaultMessage="Delete Configuration"/>
                        </Button>
                    </Row>
                    <AddAdtaSorterConfigurationModal mac={selectedMac}
                                                     open={openAddModal} setOpen={setOpenAddModal}/>
                    <DeleteAdtaSorterConfigurationModal mac={selectedMac}
                                                        open={openDeleteModal} setOpen={setOpenDeleteModal}/>
                    <div ref={tableEndRef}/>
                </Column>}
                {valueConfiguration === "Sorter Test Package" && selectedMac && <Column>
                    <Row width="100%" widths={["100", "fill", "100"]}>
                        <RefreshTimer deps={[viewModel]}/>
                        <Box></Box>
                        <Tooltip position="top" title={intl.formatMessage({
                            id: 'tooltip.scrolltobottom',
                            defaultMessage: 'Scroll to bottom'
                        })}>
                            <Button onClick={scrollToBottom}
                                    type="secondary"
                                    size="small">
                                <Icon tokens={chevronDownLargeTokens}/>
                            </Button>
                        </Tooltip>
                    </Row>
                    {viewModel.sorterTestPackageConfig[selectedMac].length === 0 ?
                        <Alert
                            type="informational"
                            size="small"
                        >
                            <FormattedMessage id="alert.testconfig"
                                              defaultMessage="No Test Package Configurations present for this MAC Address."/>
                        </Alert> :
                        <Table
                            headerRows={1}
                            spacing="small"
                            showDividers={true}
                            showStripes={true}>
                            <TableRow highlightOnHover={false}>
                                <TableCell>
                                    <FormattedMessage id="bay.index" defaultMessage="Index"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="bay.scannables" defaultMessage="Scannables"/>
                                </TableCell>
                                <TableCell>
                                    <FormattedMessage id="bay.sortzone" defaultMessage="Sort Zone"/>
                                </TableCell>
                            </TableRow>
                            {Object.values(viewModel.sorterTestPackageConfig[selectedMac].map((device, index) => (
                                <TableRow highlightOnHover={true}>
                                    <TableCell>
                                        {index + 1}
                                    </TableCell>
                                    <TableCell>
                                        {Array.isArray(device.scannables) ? device.scannables.join(' ') : device.scannables}
                                    </TableCell>
                                    <TableCell>
                                        {device.sortZone}
                                    </TableCell>
                                </TableRow>
                            )))}
                        </Table>}
                    <Row width="100%" widths={["100", "100", "fill", "100"]}>
                        <Button onClick={onClickAddSingle}
                                type="primary"
                                size="small">
                            <Icon tokens={plusCircleTokens}/>
                            <FormattedMessage id="config.addupdatetest"
                                              defaultMessage="Add/Update Sorter Test Package Configuration"/>
                        </Button>
                        <AddEditViaJsonModal/>
                        <Box></Box>
                        <Button onClick={onClickDeleteConfiguration}
                                size="small" type="tertiary">
                            <Icon tokens={trashTokens}/>
                            <FormattedMessage id="config.deletetest" defaultMessage="Delete Sorter Test Package Configuration"/>
                        </Button>
                    </Row>
                    <AddAdtaSorterTestPackageModal mac={selectedMac}
                                                   open={openAddModal} setOpen={setOpenAddModal}/>
                    <DeleteAdtaSorterTestPackageModal mac={selectedMac}
                                                      open={openDeleteModal} setOpen={setOpenDeleteModal}/>
                    <div ref={tableEndRef}/>
                </Column>}
            </Column>
        );
    }
}

export default injectIntl(AdtaDeviceConfiguration)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/AdtaDeviceConfiguration.js